<template>
  <div>
    <div v-if="changeType === 1">
      {{ $t('GlobalSetObj.Selecionadas') }}：{{ selectedData.length }}
      <div style="margin-top: 10px">
        <el-form ref="changeSiteForm" :model="changeSiteForm" label-position="top">
          <!--修改责任-->
          <el-form-item prop="selectValue">
            <template slot="label">
              <div class="selectLabel">
                <el-select
                  v-model="changeSiteForm.operateType"
                  style="width: 225px"
                  @change="switchType"
                >
                  <el-option key="1" :label="$t('tablePrice.modifyResponsibleHub')" :value="1" />
                  <el-option key="2" :label="$t('tablePrice.modifyResponsibleStage')" :value="2" />
                </el-select>
              </div>
            </template>
            <el-select
              v-if="changeSiteForm.operateType === 1"
              v-model="changeSiteForm.selectValue"
              :placeholder="this.$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in siteIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select
              v-else
              v-model="changeSiteForm.selectValue"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
              @change="changeResponsibilityStage"
            >
              <el-option
                v-for="item in responsibilityTypeList.ResponsibilityStage"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <!--责任方-->
          <el-form-item
            v-if="changeSiteForm.selectValue == 2"
            :label="$t('fixDutyFine.ResponsibleParty')"
          >
            <el-select
              v-model="changeSiteForm.responsibilityParty"
              :placeholder="$t('collectionCenter.tudo')"
              clearable
              style="width: 100%"
            >
              <el-option key="1" :label="$t('fixDutyFine.trunkLine')" :value="1" />
              <el-option key="2" :label="$t('orderCenterCont.region')" :value="2" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div v-else>
      <!--共修改-->
      <span
        style="margin-right: 20px"
      >{{ $t('fixDutyFine.TotalModification') }}：{{ changeReturnData.totalCount }}</span>
      <!--修改成功-->
      <span
        style="margin-right: 20px"
      >{{ $t('GlobalSetObj.ModificationSuccessful') }}：{{ changeReturnData.success }}</span>
      <!--修改失败-->
      <span>{{ $t('GlobalSetObj.failTotal') }}：<span style="color: #dd4a68">{{
        changeReturnData.fail
      }}</span></span>
      <div v-if="changeReturnData.fail > 0">
        <!--修改失败单号-->
        <div style="margin: 10px 0">{{ $t('fixDutyFine.ModificationFailedOrderNumber') }}：</div>
        <div style="max-height: 300px; overflow-y: auto">
          <div
            v-for="(item, index) in changeReturnData.failList"
            :key="index"
            style="margin-bottom: 5px"
          >
            {{ index + 1 }}.{{ item.waybillNumber }}，{{ item.reason }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { lmLossResponsibilityUpdateResponsibleBranch } from '@/api/definiteResponsibilityAndPenalty';

export default {
  props: {
    siteIdList: {
      type: Array,
      default: () => []
    },
    selectedData: {
      type: Array,
      default: () => []
    },
    changeType: {
      type: Number,
      default: 1
    },
    branchEnableList: {
      type: Array,
      default: () => []
    },
    responsibilityTypeList: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      changeSiteForm: {
        operateType: 1,
        selectValue: '',
        responsibilityParty: ''
      },
      changeReturnData: {
        success: 0,
        fail: 0,
        totalCount: 0,
        failList: []
      }
    };
  },
  methods: {
    changeResponsibilityStage() {
      this.changeSiteForm.responsibilityParty = '';
    },
    switchType() {
      this.changeSiteForm.selectValue = '';
      this.changeSiteForm.responsibilityParty = '';
    },
    // 修改网点
    changeSite() {
      if (this.changeSiteForm.selectValue) {
        const param = {
          ids: [],
          operateType: this.changeSiteForm.operateType,
          responsibilityParty: this.changeSiteForm.responsibilityParty
        };
        if (this.changeSiteForm.operateType === 1) {
          param.siteId = this.changeSiteForm.selectValue;
        } else {
          param.responsibilityStage = this.changeSiteForm.selectValue;
        }
        this.selectedData.map((item) => {
          param.ids.push(item.id);
        });
        if (this.changeSiteForm.selectValue == 2) {
          if (!this.changeSiteForm.responsibilityParty) {
            this.$message.error(this.$t('fixDutyFine.selectResponsibleParty'));
            return;
          }
        }
        lmLossResponsibilityUpdateResponsibleBranch(param).then((res) => {
          if (res.code === 200) {
            this.changeReturnData = {
              success: res.data.successCount,
              fail: res.data.failCount,
              totalCount: res.data.totalCount,
              failList: res.data.failReasonList
            };
            this.$emit('changeSiteData');
          }
        });
      } else {
        this.$message.error(this.$t('fixDutyFine.selectBeforeModify'));
      }
    }
  }
};
</script>

<style scoped>
>>> .selectLabel .el-input__inner {
  border: 0;
  font-weight: bold;
  padding-left: 0;
  padding-right: 0;
}
</style>
